import { render, staticRenderFns } from "./ConvoyGateAndMoveManagement.vue?vue&type=template&id=97c9383c"
import script from "./ConvoyGateAndMoveManagement.vue?vue&type=script&lang=js"
export * from "./ConvoyGateAndMoveManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports